import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AppHeader, PageShell } from "@/components/AppHeader";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const sid = params.get("session_id");
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const s = await api.paymentStatus(sid);
        if (s.payment_status === "paid") { setState("paid"); refresh(); return; }
        if (s.status === "expired" || s.payment_status === "failed") { setState("failed"); return; }
      } catch { /* keep polling */ }
      if (tries < 10) timer = setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
    return () => clearTimeout(timer);
  }, [params, refresh]);

  return (
    <PageShell>
      <AppHeader />
      <div className="card max-w-md mx-auto text-center space-y-4 !p-8" data-testid="payment-status-card">
        {state === "checking" && <><Loader2 className="mx-auto animate-spin" size={40} /><p className="font-bold" data-testid="payment-status-text">Confirming your payment...</p></>}
        {state === "paid" && <><CheckCircle2 className="mx-auto text-[var(--accent)]" size={48} /><p className="font-heading text-3xl font-extrabold uppercase" data-testid="payment-status-text">You're on the Team plan</p></>}
        {state === "failed" && <><XCircle className="mx-auto text-red-600" size={48} /><p className="font-bold" data-testid="payment-status-text">Payment didn't go through.</p></>}
        {state === "timeout" && <p className="font-bold" data-testid="payment-status-text">Still processing. Check back in a minute.</p>}
        <Link to="/coach" className="btn-primary w-full" data-testid="payment-go-dashboard">Go to my teams</Link>
      </div>
    </PageShell>
  );
}

export function PaymentCancel() {
  return (
    <PageShell>
      <AppHeader />
      <div className="card max-w-md mx-auto text-center space-y-4 !p-8" data-testid="payment-cancel-card">
        <p className="font-heading text-3xl font-extrabold uppercase">Checkout canceled</p>
        <p className="font-medium text-[var(--muted)]">No charge was made.</p>
        <Link to="/pricing" className="btn-primary w-full" data-testid="payment-back-pricing">Back to plans</Link>
      </div>
    </PageShell>
  );
}
